import React from "react";
import l from "components/util/l";

const RevisionCover = ({ 
  flow, 
  onClickNext 
}) => {

  const projectName = flow?.name;

  return (
    <div className="col-12 h-auto d-flex flex-column overflow-hidden"
      style={{ maxWidth: "65rem", borderRadius: "1.5rem"}}>

      <div className="flex-fill d-flex flex-column align-items-center justify-content-center animate__animated animate__fadeInUp p-4">
        <div className="text-center" style={{ maxWidth: "38.5rem", width: "100%" }}>

          {/* Icon */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4  mt-n2 bg-white"
            style={{
              width: "80px",
              height: "80px"
            }}
          >
            <i className="fas fa-file-contract fa-2x text-primary"></i>
          </div>

          {/* Label */}
          <p className="text-uppercase text-white font-weight-bold mb-2" style={{ letterSpacing: "0.12em", fontSize: "1rem" }}>
            {l("Propuesta Preliminar%PA518")}
          </p>

        
          {/* Project name */}
          <h1 className="font-weight-bold text-white mb-3" style={{ fontSize: "2rem", lineHeight: 1.2 }}>
            {projectName}
          </h1>

        

          {/* Divider */}
          <hr className="my-4" style={{ borderColor: "#e8edf3" }} />

          <div className="text-center mt-1 mb-5" style={{ color: "#ffffffc0", fontSize: "1rem", lineHeight: 1.65 }}>
            <label
              dangerouslySetInnerHTML={{
                __html: l(
                  "En la siguiente sección encontrarás tu propuesta inicial de proyecto donde podrás indicar los "
                    + "<b>ajustes,  mejoras o comentarios</b> para construir tu agente ideal.%PA539"
                ),
              }}
            />
          </div>

          {/* CTA */}
          <button className="btn btn-accent btn-lg w-100 mt-2" onClick={onClickNext}>
            <i className="fas fa-play mr-2" /> {l("Empezar revisión%PA537")}
          </button>

        </div>
      </div>
    </div>
  );

};

export default RevisionCover;
